import { createContext } from 'react';

export const ActiveDotContext = createContext<boolean>(false);
